/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    ProductCategory,
    ProductCategoryFromJSON,
    ProductCategoryToJSON,
    ProductCategoryCreateParams,
    ProductCategoryCreateParamsFromJSON,
    ProductCategoryCreateParamsToJSON,
    ProductCategoryList,
    ProductCategoryListFromJSON,
    ProductCategoryListToJSON,
    ProductCategoryTree,
    ProductCategoryTreeFromJSON,
    ProductCategoryTreeToJSON,
    ProductCategoryTreeList,
    ProductCategoryTreeListFromJSON,
    ProductCategoryTreeListToJSON,
    ProductCategoryUpdateParams,
    ProductCategoryUpdateParamsFromJSON,
    ProductCategoryUpdateParamsToJSON,
    ProductCreateParams,
    ProductCreateParamsFromJSON,
    ProductCreateParamsToJSON,
    ProductList,
    ProductListFromJSON,
    ProductListToJSON,
    ProductListV2,
    ProductListV2FromJSON,
    ProductListV2ToJSON,
    ProductUpdateParams,
    ProductUpdateParamsFromJSON,
    ProductUpdateParamsToJSON,
    ProductV2,
    ProductV2FromJSON,
    ProductV2ToJSON,
    ProductVariation,
    ProductVariationFromJSON,
    ProductVariationToJSON,
    ProductVariationCreateParams,
    ProductVariationCreateParamsFromJSON,
    ProductVariationCreateParamsToJSON,
    ProductVariationList,
    ProductVariationListFromJSON,
    ProductVariationListToJSON,
    ProductVariationUpdateParams,
    ProductVariationUpdateParamsFromJSON,
    ProductVariationUpdateParamsToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface CreateProductCategoryRequest {
    program_id: string;
    ProductCategoryCreateParams: ProductCategoryCreateParams;
}

export interface CreateProductV2Request {
    program_id: string;
    ProductCreateParams: ProductCreateParams;
}

export interface CreateProductVariationRequest {
    program_id: string;
    product_id: string;
    ProductVariationCreateParams: ProductVariationCreateParams;
}

export interface DeleteProductCategoryRequest {
    program_id: string;
    id: string;
}

export interface DeleteProductV2Request {
    program_id: string;
    id: string;
}

export interface DeleteProductVariationRequest {
    program_id: string;
    product_id: string;
    id: string;
}

export interface FindOneProductCategoryRequest {
    program_id: string;
    id: string;
}

export interface FindOneProductCategoryTreeRequest {
    program_id: string;
    id: string;
}

export interface FindOneProductV2Request {
    program_id: string;
    id: string;
}

export interface FindOneProductVariationRequest {
    program_id: string;
    product_id: string;
    id: string;
}

export interface FindProductCategoryTreesRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
}

export interface FindProductCategorysRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    is_root?: boolean;
}

export interface FindProductVariationsRequest {
    program_id: string;
    product_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
}

export interface FindProductsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    product_type?: Array<string>;
    product_id?: Array<string>;
    on_sale?: boolean;
}

export interface FindProductsV2Request {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    category_id?: Array<string>;
    parent_id?: string;
    is_visible?: boolean;
    on_sale?: boolean;
}

export interface UpdateProductCategoryRequest {
    program_id: string;
    id: string;
    ProductCategoryUpdateParams: ProductCategoryUpdateParams;
}

export interface UpdateProductV2Request {
    program_id: string;
    id: string;
    ProductUpdateParams: ProductUpdateParams;
}

export interface UpdateProductVariationRequest {
    program_id: string;
    product_id: string;
    id: string;
    ProductVariationUpdateParams: ProductVariationUpdateParams;
}

/**
 * 
 */
export class ProductsApi extends runtime.BaseAPI {

    /**
     * Create product category
     */
    async createProductCategoryRaw(requestParameters: CreateProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductCategory>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createProductCategory.');
        }

        if (requestParameters.ProductCategoryCreateParams === null || requestParameters.ProductCategoryCreateParams === undefined) {
            throw new runtime.RequiredError('ProductCategoryCreateParams','Required parameter requestParameters.ProductCategoryCreateParams was null or undefined when calling createProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/product_categories`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductCategoryCreateParamsToJSON(requestParameters.ProductCategoryCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCategoryFromJSON(jsonValue));
    }

    /**
     * Create product category
     */
    async createProductCategory(requestParameters: CreateProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductCategory> {
        const response = await this.createProductCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create product
     */
    async createProductV2Raw(requestParameters: CreateProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createProductV2.');
        }

        if (requestParameters.ProductCreateParams === null || requestParameters.ProductCreateParams === undefined) {
            throw new runtime.RequiredError('ProductCreateParams','Required parameter requestParameters.ProductCreateParams was null or undefined when calling createProductV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/products`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductCreateParamsToJSON(requestParameters.ProductCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductV2FromJSON(jsonValue));
    }

    /**
     * Create product
     */
    async createProductV2(requestParameters: CreateProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductV2> {
        const response = await this.createProductV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create product variation
     */
    async createProductVariationRaw(requestParameters: CreateProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductVariation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createProductVariation.');
        }

        if (requestParameters.product_id === null || requestParameters.product_id === undefined) {
            throw new runtime.RequiredError('product_id','Required parameter requestParameters.product_id was null or undefined when calling createProductVariation.');
        }

        if (requestParameters.ProductVariationCreateParams === null || requestParameters.ProductVariationCreateParams === undefined) {
            throw new runtime.RequiredError('ProductVariationCreateParams','Required parameter requestParameters.ProductVariationCreateParams was null or undefined when calling createProductVariation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/products/{product_id}/variations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.product_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductVariationCreateParamsToJSON(requestParameters.ProductVariationCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductVariationFromJSON(jsonValue));
    }

    /**
     * Create product variation
     */
    async createProductVariation(requestParameters: CreateProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductVariation> {
        const response = await this.createProductVariationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete product category
     */
    async deleteProductCategoryRaw(requestParameters: DeleteProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteProductCategory.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/product_categories/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete product category
     */
    async deleteProductCategory(requestParameters: DeleteProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteProductCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete product
     */
    async deleteProductV2Raw(requestParameters: DeleteProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteProductV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProductV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/products/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete product
     */
    async deleteProductV2(requestParameters: DeleteProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteProductV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete product variation
     */
    async deleteProductVariationRaw(requestParameters: DeleteProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteProductVariation.');
        }

        if (requestParameters.product_id === null || requestParameters.product_id === undefined) {
            throw new runtime.RequiredError('product_id','Required parameter requestParameters.product_id was null or undefined when calling deleteProductVariation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProductVariation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/products/{product_id}/variations/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.product_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete product variation
     */
    async deleteProductVariation(requestParameters: DeleteProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteProductVariationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find product category by id
     */
    async findOneProductCategoryRaw(requestParameters: FindOneProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductCategory>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneProductCategory.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/product_categories/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCategoryFromJSON(jsonValue));
    }

    /**
     * Find product category by id
     */
    async findOneProductCategory(requestParameters: FindOneProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductCategory> {
        const response = await this.findOneProductCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find product category tree by id
     */
    async findOneProductCategoryTreeRaw(requestParameters: FindOneProductCategoryTreeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductCategoryTree>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneProductCategoryTree.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneProductCategoryTree.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/product_category_trees/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCategoryTreeFromJSON(jsonValue));
    }

    /**
     * Find product category tree by id
     */
    async findOneProductCategoryTree(requestParameters: FindOneProductCategoryTreeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductCategoryTree> {
        const response = await this.findOneProductCategoryTreeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find product by id
     */
    async findOneProductV2Raw(requestParameters: FindOneProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneProductV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneProductV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/products/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductV2FromJSON(jsonValue));
    }

    /**
     * Find product by id
     */
    async findOneProductV2(requestParameters: FindOneProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductV2> {
        const response = await this.findOneProductV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find product variation by id
     */
    async findOneProductVariationRaw(requestParameters: FindOneProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductVariation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneProductVariation.');
        }

        if (requestParameters.product_id === null || requestParameters.product_id === undefined) {
            throw new runtime.RequiredError('product_id','Required parameter requestParameters.product_id was null or undefined when calling findOneProductVariation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneProductVariation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/products/{product_id}/variations/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.product_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductVariationFromJSON(jsonValue));
    }

    /**
     * Find product variation by id
     */
    async findOneProductVariation(requestParameters: FindOneProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductVariation> {
        const response = await this.findOneProductVariationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all product categories
     */
    async findProductCategoryTreesRaw(requestParameters: FindProductCategoryTreesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductCategoryTreeList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProductCategoryTrees.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/product_category_trees`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCategoryTreeListFromJSON(jsonValue));
    }

    /**
     * List all product categories
     */
    async findProductCategoryTrees(requestParameters: FindProductCategoryTreesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductCategoryTreeList> {
        const response = await this.findProductCategoryTreesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all product categories
     */
    async findProductCategorysRaw(requestParameters: FindProductCategorysRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductCategoryList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProductCategorys.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.is_root !== undefined) {
            queryParameters['is_root'] = requestParameters.is_root;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/product_categories`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCategoryListFromJSON(jsonValue));
    }

    /**
     * List all product categories
     */
    async findProductCategorys(requestParameters: FindProductCategorysRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductCategoryList> {
        const response = await this.findProductCategorysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all product variations
     */
    async findProductVariationsRaw(requestParameters: FindProductVariationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductVariationList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProductVariations.');
        }

        if (requestParameters.product_id === null || requestParameters.product_id === undefined) {
            throw new runtime.RequiredError('product_id','Required parameter requestParameters.product_id was null or undefined when calling findProductVariations.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/products/{product_id}/variations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.product_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductVariationListFromJSON(jsonValue));
    }

    /**
     * List all product variations
     */
    async findProductVariations(requestParameters: FindProductVariationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductVariationList> {
        const response = await this.findProductVariationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all Products
     */
    async findProductsRaw(requestParameters: FindProductsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProducts.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.product_type) {
            queryParameters['product_type'] = requestParameters.product_type;
        }

        if (requestParameters.product_id) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/products`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all Products
     */
    async findProducts(requestParameters: FindProductsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductList> {
        const response = await this.findProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all products
     */
    async findProductsV2Raw(requestParameters: FindProductsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductListV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProductsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.category_id) {
            queryParameters['category_id'] = requestParameters.category_id;
        }

        if (requestParameters.parent_id !== undefined) {
            queryParameters['parent_id'] = requestParameters.parent_id;
        }

        if (requestParameters.is_visible !== undefined) {
            queryParameters['is_visible'] = requestParameters.is_visible;
        }

        if (requestParameters.on_sale !== undefined) {
            queryParameters['on_sale'] = requestParameters.on_sale;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/products`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListV2FromJSON(jsonValue));
    }

    /**
     * List all products
     */
    async findProductsV2(requestParameters: FindProductsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductListV2> {
        const response = await this.findProductsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update product category
     */
    async updateProductCategoryRaw(requestParameters: UpdateProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductCategory>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateProductCategory.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductCategory.');
        }

        if (requestParameters.ProductCategoryUpdateParams === null || requestParameters.ProductCategoryUpdateParams === undefined) {
            throw new runtime.RequiredError('ProductCategoryUpdateParams','Required parameter requestParameters.ProductCategoryUpdateParams was null or undefined when calling updateProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/product_categories/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProductCategoryUpdateParamsToJSON(requestParameters.ProductCategoryUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCategoryFromJSON(jsonValue));
    }

    /**
     * Update product category
     */
    async updateProductCategory(requestParameters: UpdateProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductCategory> {
        const response = await this.updateProductCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update product
     */
    async updateProductV2Raw(requestParameters: UpdateProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateProductV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductV2.');
        }

        if (requestParameters.ProductUpdateParams === null || requestParameters.ProductUpdateParams === undefined) {
            throw new runtime.RequiredError('ProductUpdateParams','Required parameter requestParameters.ProductUpdateParams was null or undefined when calling updateProductV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/products/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProductUpdateParamsToJSON(requestParameters.ProductUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductV2FromJSON(jsonValue));
    }

    /**
     * Update product
     */
    async updateProductV2(requestParameters: UpdateProductV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductV2> {
        const response = await this.updateProductV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update product variation
     */
    async updateProductVariationRaw(requestParameters: UpdateProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProductVariation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateProductVariation.');
        }

        if (requestParameters.product_id === null || requestParameters.product_id === undefined) {
            throw new runtime.RequiredError('product_id','Required parameter requestParameters.product_id was null or undefined when calling updateProductVariation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductVariation.');
        }

        if (requestParameters.ProductVariationUpdateParams === null || requestParameters.ProductVariationUpdateParams === undefined) {
            throw new runtime.RequiredError('ProductVariationUpdateParams','Required parameter requestParameters.ProductVariationUpdateParams was null or undefined when calling updateProductVariation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/products/{product_id}/variations/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.product_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProductVariationUpdateParamsToJSON(requestParameters.ProductVariationUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductVariationFromJSON(jsonValue));
    }

    /**
     * Update product variation
     */
    async updateProductVariation(requestParameters: UpdateProductVariationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProductVariation> {
        const response = await this.updateProductVariationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
